import { tipoUsuarioClient, TipoUsuarioListaDto, TipoUsuarioDetalleDto, CrearTipoUsuarioDto, ActualizarTipoUsuarioDto } from '@/core/sdk/modules/administracion/tipoUsuarioClient';

/**
 * Servicio de tipos de usuario que expone métodos para gestión de tipos de usuario
 * Sigue el mismo patrón que authService
 */
export const tipoUsuarioService = {
    /**
     * Obtener todos los tipos de usuario
     */
    getAll: async (): Promise<TipoUsuarioListaDto[]> => {
        const response = await tipoUsuarioClient.listar();

        if (!response.success || !response.data) {
            throw new Error(response.message || 'Error al obtener tipos de usuario');
        }

        // Extraer el array de tiposUsuario del objeto de paginación
        return response.data.tiposUsuario;
    },

    /**
     * Obtener un tipo de usuario por ID
     */
    getById: async (id: number): Promise<TipoUsuarioDetalleDto> => {
        const response = await tipoUsuarioClient.obtener(id);

        if (!response.success || !response.data) {
            throw new Error(response.message || 'Error al obtener tipo de usuario');
        }

        return response.data;
    },

    /**
     * Crear un nuevo tipo de usuario
     */
    create: async (data: CrearTipoUsuarioDto): Promise<TipoUsuarioDetalleDto> => {
        const response = await tipoUsuarioClient.crear(data);

        if (!response.success || !response.data) {
            throw new Error(response.message || 'Error al crear tipo de usuario');
        }

        return response.data;
    },

    /**
     * Actualizar un tipo de usuario existente
     */
    update: async (id: number, data: ActualizarTipoUsuarioDto): Promise<TipoUsuarioDetalleDto> => {
        const response = await tipoUsuarioClient.actualizar(id, data);

        if (!response.success || !response.data) {
            throw new Error(response.message || 'Error al actualizar tipo de usuario');
        }

        return response.data;
    },

    /**
     * Eliminar un tipo de usuario
     */
    delete: async (id: number): Promise<void> => {
        const response = await tipoUsuarioClient.eliminar(id);

        if (!response.success) {
            throw new Error(response.message || 'Error al eliminar tipo de usuario');
        }
    }
};

// Export por defecto y nombrado para máxima flexibilidad
export default tipoUsuarioService;
